{
  "about.blocks": "Tálmaðir ambætarar",
  "about.contact": "Samband:",
  "about.default_locale": "Sjálvvirði",
  "about.disclaimer": "Mastodon er fríur ritbúnaður við opnari keldu og eitt vørumerki hjá Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Ókent orsøk",
  "about.domain_blocks.preamble": "Yvirhøvur, so loyvir Mastodon tær at síggja innihald frá og at samvirka við brúkarar frá ein og hvørjum ambætara í fediverse. Undantøkini, sum eru gjørd á júst hesum ambætaranum, eru hesi.",
  "about.domain_blocks.silenced.explanation": "Yvirhøvur, so sært tú ikki vangar og innihald frá hesum ambætaranum, uttan so at tú skilliga leitar hesi upp ella velur tey við at fylgja teimum.",
  "about.domain_blocks.silenced.title": "Avmarkað",
  "about.domain_blocks.suspended.explanation": "Ongar dátur frá hesum ambætara verða viðgjørd, goymd ella deild, tað ger, at samskifti við aðrar ambætarar er iki møguligt.",
  "about.domain_blocks.suspended.title": "Gjørt óvirkið",
  "about.language_label": "Mál",
  "about.not_available": "Hetta er ikki tøkt á føroyska servaranum enn.",
  "about.powered_by": "Miðfirra almennur miðil koyrandi á {mastodon}",
  "about.rules": "Ambætarareglur",
  "account.account_note_header": "Persónlig viðmerking",
  "account.activity": "Virksemi",
  "account.add_note": "Legg persónliga notu afturat",
  "account.add_or_remove_from_list": "Legg afturat ella tak av listum",
  "account.badges.admin": "Umsitari",
  "account.badges.blocked": "Blokerað/ur",
  "account.badges.bot": "Bottur",
  "account.badges.domain_blocked": "Blokerað økisnavn",
  "account.badges.group": "Bólkur",
  "account.badges.muted": "Doyvdur",
  "account.badges.muted_until": "Doyvdur til {until}",
  "account.block": "Banna @{name}",
  "account.block_domain": "Banna økisnavnið {domain}",
  "account.block_short": "Banna",
  "account.blocked": "Bannað/ur",
  "account.cancel_follow_request": "Strika fylgjaraumbøn",
  "account.copy": "Avrita leinki til vangan",
  "account.direct": "Umrøð @{name} privat",
  "account.disable_notifications": "Ikki boða mær frá, tá @{name} skrivar",
  "account.edit_note": "Rætta persónliga notu",
  "account.edit_profile": "Broyt vanga",
  "account.edit_profile_short": "Rætta",
  "account.enable_notifications": "Boða mær frá, tá @{name} skrivar",
  "account.endorse": "Víst á vangamyndini",
  "account.familiar_followers_many": "{name1}, {name2} og {othersCount, plural, one {ein annar/onnur tú kennir} other {# onnur tú kennir}} fylgja",
  "account.familiar_followers_one": "{name1} fylgir",
  "account.familiar_followers_two": "{name1} og {name2} fylgja",
  "account.featured": "Sermerkt",
  "account.featured.accounts": "Vangar",
  "account.featured.collections": "Søvn",
  "account.field_overflow": "Vís alt innihaldið",
  "account.filters.all": "Alt virksemi",
  "account.filters.boosts_toggle": "Vís stimbranir",
  "account.filters.posts_boosts": "Postar og stimbranir",
  "account.filters.posts_only": "Postar",
  "account.filters.posts_replies": "Postar og svar",
  "account.filters.replies_toggle": "Vís svar",
  "account.follow": "Fylg",
  "account.follow_back": "Fylg aftur",
  "account.follow_back_short": "Fylg aftur",
  "account.follow_request": "Umbønir um at fylgja tær",
  "account.follow_request_cancel": "Strika víðaribeining",
  "account.follow_request_cancel_short": "Ógilda",
  "account.follow_request_short": "Áheitan",
  "account.followers": "Fylgjarar",
  "account.followers.empty": "Ongar fylgjarar enn.",
  "account.followers_counter": "{count, plural, one {{counter} fylgjari} other {{counter} fylgjarar}}",
  "account.followers_you_know_counter": "{counter} tú kennir",
  "account.following": "Fylgir",
  "account.following_counter": "{count, plural, one {{counter} fylgir} other {{counter} fylgja}}",
  "account.follows.empty": "Hesin brúkari fylgir ongum enn.",
  "account.follows_you": "Fylgir tær",
  "account.go_to_profile": "Far til vanga",
  "account.hide_reblogs": "Fjal stimbran frá @{name}",
  "account.in_memoriam": "In memoriam.",
  "account.joined_short": "Gjørdist limur",
  "account.languages": "Broyt fylgd mál",
  "account.link_verified_on": "Ognarskapur av hesum leinki var eftirkannaður {date}",
  "account.locked_info": "Privatverjustøðan hjá hesi kontuni er sett til at vera læst. Eigarin avger í hvørjum einstøkum føri, hvør kann fylgja teimum.",
  "account.media": "Miðlar",
  "account.mention": "Nevn @{name}",
  "account.menu.add_to_list": "Legg afturat lista…",
  "account.menu.block": "Blokera kontu",
  "account.menu.block_domain": "Blokera {domain}",
  "account.menu.copied": "Avritaði kontuleinki til setiborðið",
  "account.menu.copy": "Avrita leinki",
  "account.menu.direct": "Umrøð privat",
  "account.menu.hide_reblogs": "Fjal stimbranir í tíðarlinju",
  "account.menu.mention": "Umrøð",
  "account.menu.mute": "Doyv kontu",
  "account.menu.note.description": "Einans sjónligt fyri teg",
  "account.menu.open_original_page": "Vís á {domain}",
  "account.menu.remove_follower": "Strika fylgjara",
  "account.menu.report": "Melda kontu",
  "account.menu.share": "Deil…",
  "account.menu.show_reblogs": "Vís stimbranir í tíðarlinju",
  "account.menu.unblock": "Strika blokering av kontu",
  "account.menu.unblock_domain": "Strika blokering av {domain}",
  "account.menu.unmute": "Strika doyving av kontu",
  "account.moved_to": "{name} hevur gjørt kunnugt, at teirra nýggja konta er nú:",
  "account.mute": "Sløkk @{name}",
  "account.mute_notifications_short": "Sløkk fráboðanir",
  "account.mute_short": "Doyv",
  "account.muted": "Sløkt/ur",
  "account.mutual": "Tit fylgja hvønn annan",
  "account.name.help.domain": "{domain} er ambætarin, sum hýsir vangan og postarnar hjá brúkaranum.",
  "account.name.help.domain_self": "{domain} er tín ambætari, sum hýsir tín vanga og postar.",
  "account.name.help.header": "Eitt hald er sum ein teldupostbústaður",
  "account.name.help.username": "{username} er brúkaranavnið hjá hesari kontuni á teirra ambætara. Onkur á einum øðrum ambætara kann hava sama brúkaranavn.",
  "account.name.help.username_self": "{username} er brúkaranavnið hjá tær á hesum ambætaranum. Onkur á einum øðrum ambætara kann hava sama brúkaranavn.",
  "account.name_info": "Hvat merkir hetta?",
  "account.no_bio": "Lýsing vantar.",
  "account.node_modal.callout": "Einans tú sær tínar persónligu notur.",
  "account.node_modal.edit_title": "Rætta persónliga notu",
  "account.node_modal.error_unknown": "Eydnaðist ikki at goyma notuna",
  "account.node_modal.field_label": "Persónlig nota",
  "account.node_modal.save": "Goym",
  "account.node_modal.title": "Legg persónliga notu afturat",
  "account.note.edit_button": "Rætta",
  "account.note.title": "Persónlig nota (einans sjónlig fyri teg)",
  "account.open_original_page": "Opna upprunasíðuna",
  "account.posts": "Uppsløg",
  "account.remove_from_followers": "Strika {name} av fylgjaralista",
  "account.report": "Melda @{name}",
  "account.requested_follow": "{name} hevur biðið um at fylgja tær",
  "account.share": "Deil vanga @{name}'s",
  "account.show_reblogs": "Vís stimbran frá @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} postur} other {{counter} postar}}",
  "account.timeline.pinned": "Fest",
  "account.timeline.pinned.view_all": "Sí allar festar postar",
  "account.unblock": "Banna ikki @{name}",
  "account.unblock_domain": "Banna ikki økisnavnið {domain}",
  "account.unblock_domain_short": "Banna ikki",
  "account.unblock_short": "Banna ikki",
  "account.unendorse": "Vís ikki á vanga",
  "account.unfollow": "Fylg ikki",
  "account.unmute": "Doyv ikki @{name}",
  "account.unmute_notifications_short": "Tendra fráboðanir",
  "account.unmute_short": "Doyv ikki",
  "account_edit.bio.placeholder": "Legg eina stutta kunning afturat soleiðis at onnur kunnu eyðmerkja teg.",
  "account_edit.bio.title": "Ævilýsing",
  "account_edit.bio_modal.add_title": "Legg ævilýsing afturat",
  "account_edit.bio_modal.edit_title": "Rætta ævilýsing",
  "account_edit.column_button": "Liðugt",
  "account_edit.column_title": "Rætta vanga",
  "account_edit.custom_fields.placeholder": "Legg tíni forheiti, uttanhýsis leinki ella okkurt annað, sum tú kundi hugsað tær at deilt.",
  "account_edit.custom_fields.title": "Serfelt",
  "account_edit.display_name.placeholder": "Títt vísta navn er soleiðis sum navnið hjá tær verður víst á vanganum og á tíðarrásum.",
  "account_edit.display_name.title": "Víst navn",
  "account_edit.featured_hashtags.placeholder": "Hjálp øðrum at eyðmekja og hava skjóta atgongd til tíni yndisevni.",
  "account_edit.featured_hashtags.title": "Sermerkt frámerki",
  "account_edit.name_modal.add_title": "Legg víst navn afturat",
  "account_edit.name_modal.edit_title": "Rætta víst navn",
  "account_edit.profile_tab.button_label": "Tillaga",
  "account_edit.profile_tab.hint.description": "Hesi stillingarnar tillaga tað, sum brúkarar síggja á {server} í almennu appunum, men tær eru kanska ikki galdandi fyri brúkarar á øðrum servarum og appum hjá triðjapørtum.",
  "account_edit.profile_tab.hint.title": "Vísingar eru framvegis ymiskar",
  "account_edit.profile_tab.show_featured.description": "'Sermerkt' er eitt valfrítt spjaldur, har tú kanst sýna aðrar kontur fram.",
  "account_edit.profile_tab.show_featured.title": "Vís 'Sermerkt\" spjaldur",
  "account_edit.profile_tab.show_media.description": "'Miðlar' er eitt valfrítt spjaldur, sum vísur tínar postar, sum innihalda myndir ella sjónfílur.",
  "account_edit.profile_tab.show_media.title": "Vís 'Miðlar' spjaldur",
  "account_edit.profile_tab.show_media_replies.description": "Tá tað er virkið, vísir Miðlar spjaldrið bæði tínar postar og svar til postar hjá øðrum.",
  "account_edit.profile_tab.show_media_replies.title": "Írokna svar á 'Miðlar' spjaldrinum",
  "account_edit.save": "Goym",
  "account_edit_tags.add_tag": "Legg #{tagName} afturat",
  "account_edit_tags.help_text": "Sermerkt frámerki hjálpa brúkarum at varnast og virka saman við vanga tínum. Tey síggjast sum filtur á virksemisvísingini av vanga tínum.",
  "account_edit_tags.search_placeholder": "Áset eitt frámerki…",
  "account_edit_tags.suggestions": "Uppskot:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# postur} other {# postar}}",
  "account_note.placeholder": "Klikka fyri at leggja viðmerking afturat",
  "admin.dashboard.daily_retention": "Hvussu nógvir brúkarar eru eftir, síðani tey skrásettu seg, roknað í døgum",
  "admin.dashboard.monthly_retention": "Hvussu nógvir brúkarar eru eftir síðani tey skrásettu seg, roknað í mánaðum",
  "admin.dashboard.retention.average": "Miðal",
  "admin.dashboard.retention.cohort": "Skrásetingarmánaði",
  "admin.dashboard.retention.cohort_size": "Nýggir brúkarar",
  "admin.impact_report.instance_accounts": "Kontuvangar, sum hetta hevði strikað",
  "admin.impact_report.instance_followers": "Fylgjarar, sum okkara brúkarar høvdu mist",
  "admin.impact_report.instance_follows": "Fylgjarar, sum teirra brúkarar høvdu mist",
  "admin.impact_report.title": "Samandráttur av ávirkan",
  "alert.rate_limited.message": "Vinarliga royn aftur aftaná {retry_time, time, medium}.",
  "alert.rate_limited.title": "Avmarkaður títtleiki",
  "alert.unexpected.message": "Ein óvæntaður feilur kom fyri.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Annar tekstur",
  "alt_text_modal.add_alt_text": "Legg alternativan tekst afturat",
  "alt_text_modal.add_text_from_image": "Legg tekst frá mynd afturat",
  "alt_text_modal.cancel": "Angra",
  "alt_text_modal.change_thumbnail": "Broyt smámynd",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Lýs hetta fyri fólk við tey, ið hava niðursetta hoyrn…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Lýs hetta fyri fólk við tey, ið hava avmarkaða sjón…",
  "alt_text_modal.done": "Liðugt",
  "announcement.announcement": "Kunngerð",
  "annual_report.announcement.action_build": "Ger mítt Wrapstodon",
  "annual_report.announcement.action_dismiss": "Nei takk",
  "annual_report.announcement.action_view": "Vís mítt Wrapstodon",
  "annual_report.announcement.description": "Fá meira at vita um títt virksemi á Mastodon seinasta árið.",
  "annual_report.announcement.title": "Wrapstodon {year} er komið",
  "annual_report.nav_item.badge": "Nýtt",
  "annual_report.shared_page.donate": "Stuðla",
  "annual_report.shared_page.footer": "Gjørt við {heart} av Mastodon toyminum",
  "annual_report.shared_page.footer_server_info": "{username} brúkar {domain}, ein av fleiri felagsskapum, sum er drivin av Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} helt fram at veiða postar at lyfta, og styrkti aðrar skaparar við perfektum sikti.",
  "annual_report.summary.archetype.booster.desc_self": "Tú helt fram at veiða postar at lyfta, og styrkti aðrar skaparar við perfektum sikti.",
  "annual_report.summary.archetype.booster.name": "Bogaskjúttin",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Vit vita, at {name} var úti har onkustaðni og neyt Mastodon uppá sín egna stilla máta.",
  "annual_report.summary.archetype.lurker.desc_self": "Vit vita, at tú var úti har onkustaðni og neyt Mastodon uppá tín egna stilla máta.",
  "annual_report.summary.archetype.lurker.name": "Stóikarin",
  "annual_report.summary.archetype.oracle.desc_public": "{name} gjørdi fleiri nýggjar postar enn svar og helt Mastodon feskt og framtíðarrættað.",
  "annual_report.summary.archetype.oracle.desc_self": "Tú gjørdi fleiri nýggjar postar enn svar og helt Mastodon feskt og framtíðarrættað.",
  "annual_report.summary.archetype.oracle.name": "Oraklið",
  "annual_report.summary.archetype.pollster.desc_public": "{name} stovnaði fleiri atkvøðugreiðslur enn onnur sløg av postum og dyrkaði forvitni á Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Tú stovnaði fleiri atkvøðugreiðslur enn onnur sløg av postum og dyrkaði forvitni á Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Undrandi",
  "annual_report.summary.archetype.replier.desc_public": "{name} svaraði ofta til postar hjá øðrum og ríkaði Mastodon við nýggjum kjaki.",
  "annual_report.summary.archetype.replier.desc_self": "Tú svaraði ofta til postar hjá øðrum og ríkaði Mastodon við nýggjum kjaki.",
  "annual_report.summary.archetype.replier.name": "Firvaldurin",
  "annual_report.summary.archetype.reveal": "Avdúka mítt frumsnið",
  "annual_report.summary.archetype.reveal_description": "Takk fyri at tú er partur av Mastodon! Nú er tíðin komin at finna útav hvat frumsnið tú fall inn í í {year}.",
  "annual_report.summary.archetype.title_public": "Frumsniðið hjá {name}",
  "annual_report.summary.archetype.title_self": "Títt frumsnið",
  "annual_report.summary.close": "Lat aftur",
  "annual_report.summary.copy_link": "Avrita leinki",
  "annual_report.summary.followers.new_followers": "{count, plural, one {{counter} nýggjur fylgjari} other {{counter} nýggir fylgjarar}}",
  "annual_report.summary.highlighted_post.boost_count": "Hesin posturin var lyftur {count, plural, one {eina ferð} other {# ferðir}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Hesin posturin var yndismerktur {count, plural, one {eina ferð} other {# ferðir}}.",
  "annual_report.summary.highlighted_post.reply_count": "Hesin posturin fekk {count, plural, one {eitt svar} other {# svar}}.",
  "annual_report.summary.highlighted_post.title": "Best umtókti postur",
  "annual_report.summary.most_used_app.most_used_app": "mest brúkta app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "mest brúkta frámerki",
  "annual_report.summary.most_used_hashtag.used_count": "Tú brúkti hetta frámerkið í {count, plural, one {einum posti} other {# postum}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} brúkti hetta frámerkið í {count, plural, one {einum posti} other {# postum}}.",
  "annual_report.summary.new_posts.new_posts": "nýggir postar",
  "annual_report.summary.percentile.text": "<topLabel>Tað fær teg í topp</topLabel><percentage></percentage><bottomLabel>av {domain} brúkarum.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Vit fara ikki at fortelja Bernie tað.",
  "annual_report.summary.share_elsewhere": "Deil aðrastaðni",
  "annual_report.summary.share_message": "Eg fekk {archetype} frumsniðið!",
  "annual_report.summary.share_on_mastodon": "Deil á Mastodon",
  "attachments_list.unprocessed": "(óviðgjørt)",
  "audio.hide": "Fjal ljóð",
  "block_modal.remote_users_caveat": "Vit biðja ambætaran {domain} virða tína avgerð. Kortini er eingin vissa um samsvar, av tí at fleiri ambætarar handfara blokkar ymiskt. Almennir postar kunnu framvegis vera sjónligir fyri brúkarar, sum ikki eru innritaðir.",
  "block_modal.show_less": "Vís minni",
  "block_modal.show_more": "Vís meiri",
  "block_modal.they_will_know": "Tey síggja, at tey eru bannað.",
  "block_modal.title": "Banna brúkara?",
  "boost_modal.combo": "Tú kanst trýsta á {combo} fyri at loypa uppum hetta næstu ferð",
  "boost_modal.reblog": "Stimbra post?",
  "boost_modal.undo_reblog": "Strika stimbran av posti?",
  "bundle_column_error.copy_stacktrace": "Avrita feilfráboðan",
  "bundle_column_error.error.body": "Umbidna síðan kann ikki vísast. Tað kann vera orsakað av einum feili í koduni hjá okkum ella tað kann vera orsakað av kaganum, sum tú brúkar.",
  "bundle_column_error.error.title": "Áh, nei!",
  "bundle_column_error.network.body": "Har hendir ein feilur, tá hendan síðan var tikin fram. Tað kann vera orsakað av einum bráðfeingis trupulleika við netsambandinum hjá tær ella við hesum ambætaranum.",
  "bundle_column_error.network.title": "Netverksfeilur",
  "bundle_column_error.retry": "Royn umaftur",
  "bundle_column_error.return": "Aftur til forsíðuna",
  "bundle_column_error.routing.body": "Tað bar ikki til at finna umbidnu síðuna. Er URL'urin rættur?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Lat aftur",
  "bundle_modal_error.message": "Okkurt gekk galið, tá hendan síðan bleiv innlisin.",
  "bundle_modal_error.retry": "Royn umaftur",
  "callout.dismiss": "Avvís",
  "carousel.current": "<sr>Glæra</sr> {current, number} / {max, number}",
  "carousel.slide": "Glæra {current, number} av {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} viðmæld tekn",
  "character_counter.required": "{currentLength}/{maxLength} tekn",
  "closed_registrations.other_server_instructions": "Av tí at Mastodon er desentraliserað, kanst tú stovna eina kontu á einum øðrum ambætara og framvegis virka saman við hesum ambætaranum.",
  "closed_registrations_modal.description": "Tað er ikki møguligt at stovna sær eina kontu á {domain} í løtuni, men vinarliga hav í huga at tær nýtist ikki eina kontu á júst {domain} fyri at brúka Mastodon.",
  "closed_registrations_modal.find_another_server": "Finn ein annan ambætara",
  "closed_registrations_modal.preamble": "Mastodon er desentraliserað, so óansæð hvar tú stovnar tína kontu, so ber til hjá tær at fylgja og virka saman við einum og hvørjum á hesum ambætaranum. Tað ber enntá til at hýsa tí sjálvi!",
  "closed_registrations_modal.title": "At stovna kontu á Mastodon",
  "collection.share_modal.share_via_post": "Posta á Mastodon",
  "collection.share_modal.share_via_system": "Deil til…",
  "collection.share_modal.title": "Deil savn",
  "collection.share_modal.title_new": "Deil títt nýggja savn!",
  "collection.share_template_other": "Hygg at hesum kula savninum: {link}",
  "collection.share_template_own": "Hygg at mínum nýggja savni: {link}",
  "collections.account_count": "{count, plural, one {# konta} other {# kontur}}",
  "collections.accounts.empty_title": "Hetta savnið er tómt",
  "collections.collection_description": "Lýsing",
  "collections.collection_name": "Navn",
  "collections.collection_topic": "Evni",
  "collections.confirm_account_removal": "Er tú vís/ur í, at tú vilt strika hesa kontuna frá hesum savninum?",
  "collections.content_warning": "Innihaldsávaring",
  "collections.continue": "Halt fram",
  "collections.create.accounts_title": "Hvønn vil tú framhevja í hesum savninum?",
  "collections.create.basic_details_title": "Grundleggjandi smálutir",
  "collections.create.steps": "Stig {step}/{total}",
  "collections.create_collection": "Ger savn",
  "collections.delete_collection": "Strika savn",
  "collections.description_length_hint": "Í mesta lagi 100 tekn",
  "collections.detail.loading": "Innlesi savn…",
  "collections.detail.share": "Deil hetta savnið",
  "collections.edit_details": "Rætta smálutir",
  "collections.last_updated_at": "Seinast dagført: {date}",
  "collections.manage_accounts": "Umsit kontur",
  "collections.mark_as_sensitive": "Merk sum viðkvæmt",
  "collections.mark_as_sensitive_hint": "Fjalið lýsingina av og konturnar hjá savninum aftan fyri eina innihaldsávaring. Savnsnavnið verður framvegis sjónligt.",
  "collections.name_length_hint": "Í mesta lagi 40 tekn",
  "collections.new_collection": "Nýtt savn",
  "collections.report_collection": "Melda hetta savnið",
  "collections.search_accounts_max_reached": "Tú hevur lagt afturat mesta talið av kontum",
  "collections.sensitive": "Viðkvæmt",
  "collections.topic_hint": "Legg afturat eitt frámerki, sum hjálpir øðrum at skilja høvuðevnið í hesum savninum.",
  "collections.view_collection": "Vís savn",
  "collections.visibility_public": "Alment",
  "collections.visibility_public_hint": "Kann uppdagast í leitiúrslitum og øðrum økjum, har viðmæli síggjast.",
  "collections.visibility_title": "Sýni",
  "collections.visibility_unlisted": "Ikki listað",
  "collections.visibility_unlisted_hint": "Sjónligt fyri øll við einum leinki. Fjalt frá leitiúrslitum og viðmælum.",
  "column.about": "Um",
  "column.blocks": "Bannaðir brúkarar",
  "column.bookmarks": "Bókamerki",
  "column.community": "Lokal tíðarlinja",
  "column.create_list": "Ger lista",
  "column.direct": "Privatar umrøður",
  "column.directory": "Blaða gjøgnum vangar",
  "column.domain_blocks": "Bannað økisnøvn",
  "column.edit_list": "Broyt lista",
  "column.favourites": "Dámdir postar",
  "column.firehose": "Beinleiðis rásir",
  "column.firehose_local": "Beinleiðis rás hjá hesum ambætaranum",
  "column.firehose_singular": "Beinleiðis rás",
  "column.follow_requests": "Umbønir at fylgja",
  "column.home": "Heim",
  "column.list_members": "Rætta limalista",
  "column.lists": "Listar",
  "column.mutes": "Sløktir brúkarar",
  "column.notifications": "Fráboðanir",
  "column.pins": "Festir postar",
  "column.public": "Felags tíðarlinja",
  "column_back_button.label": "Aftur",
  "column_header.hide_settings": "Fjal stillingar",
  "column_header.moveLeft_settings": "Flyt teigin til vinstru",
  "column_header.moveRight_settings": "Flyt teigin til høgru",
  "column_header.pin": "Fest",
  "column_header.show_settings": "Vís stillingar",
  "column_header.unpin": "Loys",
  "column_search.cancel": "Angra",
  "combobox.close_results": "Lat úrslit aftur",
  "combobox.loading": "Innlesi",
  "combobox.no_results_found": "Eingi úrslit av hesi leitingini",
  "combobox.open_results": "Lat úrslit upp",
  "combobox.results_available": "{count, plural, one {# uppskot} other {# uppskot}} tøk. Brúka upp- og niður-pílarnar fyri at navigera. Trýst á Enter fyri at velja.",
  "community.column_settings.local_only": "Einans lokalt",
  "community.column_settings.media_only": "Einans miðlar",
  "community.column_settings.remote_only": "Einans útifrá",
  "compose.error.blank_post": "Postar kunnu ikki vera blankir.",
  "compose.language.change": "Skift mál",
  "compose.language.search": "Leita eftir málum...",
  "compose.published.body": "Postur útgivin.",
  "compose.published.open": "Opin",
  "compose.saved.body": "Postur goymdur.",
  "compose_form.direct_message_warning_learn_more": "Fleiri upplýsingar",
  "compose_form.encryption_warning": "Postar á Mastodon eru ikki bronglaðir úr enda í annan. Lat vera við at deila viðkvæmar upplýsingar á Mastodon.",
  "compose_form.hashtag_warning": "Hesin posturin verður ikki listaður undir nøkrum frámerki, tí hann er ikki almennur. Tað ber einans til at leita eftir almennum postum eftir frámerki.",
  "compose_form.lock_disclaimer": "Kontoin hjá tær er ikki {locked}. Øll kunnu fylgja tær og lesa tað, tú bert letur fyljgarar lesa.",
  "compose_form.lock_disclaimer.lock": "læst",
  "compose_form.placeholder": "Hvat hevur tú í huga?",
  "compose_form.poll.duration": "Atkvøðugreiðslutíð",
  "compose_form.poll.multiple": "Fleiri valmøguleikar",
  "compose_form.poll.option_placeholder": "Valmøguleiki {number}",
  "compose_form.poll.single": "Einfalt val",
  "compose_form.poll.switch_to_multiple": "Broyt atkvøðugreiðslu til at loyva fleiri svarum",
  "compose_form.poll.switch_to_single": "Broyt atkvøðugreiðslu til einstakt svar",
  "compose_form.poll.type": "Stílur",
  "compose_form.publish": "Posta",
  "compose_form.reply": "Svara",
  "compose_form.save_changes": "Dagfør",
  "compose_form.spoiler.marked": "Ávaring um at strika innihald",
  "compose_form.spoiler.unmarked": "Skriva ávaring um innihald",
  "compose_form.spoiler_placeholder": "Innihaldsávaring (valfrí)",
  "confirmation_modal.cancel": "Strika",
  "confirmations.block.confirm": "Banna",
  "confirmations.delete.confirm": "Strika",
  "confirmations.delete.message": "Er tað tilætlað, at tú strikar hetta uppslagið?",
  "confirmations.delete.title": "Strika post?",
  "confirmations.delete_collection.confirm": "Strika",
  "confirmations.delete_collection.message": "Hendan atgerðin kann ikki angrast.",
  "confirmations.delete_collection.title": "Strika \"{name}\"?",
  "confirmations.delete_list.confirm": "Strika",
  "confirmations.delete_list.message": "Ert tú vís/ur í, at tú vilt strika hetta uppslagið?",
  "confirmations.delete_list.title": "Strika lista?",
  "confirmations.discard_draft.confirm": "Vraka og halt fram",
  "confirmations.discard_draft.edit.cancel": "Tak uppaftur rætting",
  "confirmations.discard_draft.edit.message": "Heldur tú fram, vrakast broytingar, sum tú hevur gjørt í postinum, ið tú er í ferð við at rætta.",
  "confirmations.discard_draft.edit.title": "Vraka broytingar í postinum hjá tær?",
  "confirmations.discard_draft.post.cancel": "Halt fram við kladduni",
  "confirmations.discard_draft.post.message": "Heldur tú fram, vrakast posturin, sum tú er í ferð við at stovna.",
  "confirmations.discard_draft.post.title": "Vraka kladdupostin?",
  "confirmations.discard_edit_media.confirm": "Vraka",
  "confirmations.discard_edit_media.message": "Tú hevur broytingar í miðlalýsingini ella undansýningini, sum ikki eru goymdar. Vilt tú kortini vraka?",
  "confirmations.follow_to_list.confirm": "Fylg og legg afturat lista",
  "confirmations.follow_to_list.message": "Tú mást fylgja {name} fyri at leggja tey afturat einum lista.",
  "confirmations.follow_to_list.title": "Fylg brúkara?",
  "confirmations.logout.confirm": "Rita út",
  "confirmations.logout.message": "Ert tú vís/ur í, at tú vilt útrita teg?",
  "confirmations.logout.title": "Rita út?",
  "confirmations.missing_alt_text.confirm": "Legg alternativan tekst afturat",
  "confirmations.missing_alt_text.message": "Posturin hjá tær inniheldur miðlar uttan alternativan tekst. Leggur tú lýsingar afturat verður tilfarið hjá tær atkomuligt hjá fleiri.",
  "confirmations.missing_alt_text.secondary": "Posta allíkavæl",
  "confirmations.missing_alt_text.title": "Legg alternativan tekst afturat?",
  "confirmations.mute.confirm": "Doyv",
  "confirmations.private_quote_notify.cancel": "Aftur til rættingar",
  "confirmations.private_quote_notify.confirm": "Útgev post",
  "confirmations.private_quote_notify.do_not_show_again": "Ikki vísa hesi boðini aftur",
  "confirmations.private_quote_notify.message": "Persónurin, sum tú siterar, og onnur, sum eru nevnd, verða kunnaði og kunnu síggja postin hjá tær, sjálvt um tey ikki fylgja tær.",
  "confirmations.private_quote_notify.title": "Deil við fylgjarum og nevndum brúkarum?",
  "confirmations.quiet_post_quote_info.dismiss": "Ikki minna meg á tað aftur",
  "confirmations.quiet_post_quote_info.got_it": "Eg skilji",
  "confirmations.quiet_post_quote_info.message": "Tá tú siterar ein stillan almennan post, verður posturin hjá tær fjaldur frá tíðarlinjum, ið vísa vælumtóktar postar.",
  "confirmations.quiet_post_quote_info.title": "Sitera stillar almennar postar",
  "confirmations.redraft.confirm": "Sletta og skriva umaftur",
  "confirmations.redraft.message": "Vilt tú veruliga strika hendan postin og í staðin gera hann til eina nýggja kladdu? Yndisfrámerki og framhevjanir blíva burtur, og svar til upprunapostin missa tilknýtið.",
  "confirmations.redraft.title": "Strika & ger nýtt uppskot um post?",
  "confirmations.remove_from_followers.confirm": "Strika fylgjara",
  "confirmations.remove_from_followers.message": "{name} fer ikki longur at fylgja tær. Er tú vís/ur í at tú vilt halda fram?",
  "confirmations.remove_from_followers.title": "Strika fylgjara?",
  "confirmations.revoke_quote.confirm": "Strika post",
  "confirmations.revoke_quote.message": "Hendan atgerðin kann ikki angrast.",
  "confirmations.revoke_quote.title": "Strika post?",
  "confirmations.unblock.confirm": "Banna ikki",
  "confirmations.unblock.title": "Banna ikki {name}?",
  "confirmations.unfollow.confirm": "Fylg ikki",
  "confirmations.unfollow.title": "Gevst at fylgja {name}?",
  "confirmations.withdraw_request.confirm": "Tak umbønina aftur",
  "confirmations.withdraw_request.title": "Tak umbønina um at fylgja {name} aftur?",
  "content_warning.hide": "Fjal post",
  "content_warning.show": "Vís kortini",
  "content_warning.show_more": "Vís meiri",
  "conversation.delete": "Strika samrøðu",
  "conversation.mark_as_read": "Merk sum lisið",
  "conversation.open": "Vís samrøðu",
  "conversation.with": "Við {names}",
  "copy_icon_button.copied": "Avritað til setiborðið",
  "copy_icon_button.copy_this_text": "Avrita leinki til setiborðið",
  "copypaste.copied": "Avritað",
  "copypaste.copy_to_clipboard": "Avrita til setiborðið",
  "directory.federated": "Frá tí kenda fediversinum",
  "directory.local": "Einans frá {domain}",
  "directory.new_arrivals": "Nýkomið",
  "directory.recently_active": "Nýliga virkin",
  "disabled_account_banner.account_settings": "Kontustillingar",
  "disabled_account_banner.text": "Konta tín {disabledAccount} er í løtuni óvirkin.",
  "dismissable_banner.community_timeline": "Hesir er nýggjastu almennu postarnir frá fólki, hvørs kontur eru hýstar av {domain}.",
  "dismissable_banner.dismiss": "Avvís",
  "dismissable_banner.public_timeline": "Hetta eru nýggjastu almennu postarnir frá fólki á fediversinum, sum fólk á {domain} fylgja.",
  "domain_block_modal.block": "Banna ambætara",
  "domain_block_modal.block_account_instead": "Banna @{name} ístaðin",
  "domain_block_modal.they_can_interact_with_old_posts": "Fólk frá hesum ambætara kunnu svara tínum gomlu postum.",
  "domain_block_modal.they_cant_follow": "Eingin frá hesum ambætara kann fylgja tær.",
  "domain_block_modal.they_wont_know": "Tey vita ikki, at tey eru bannað.",
  "domain_block_modal.title": "Banna økisnavni?",
  "domain_block_modal.you_will_lose_num_followers": "Tú missir {followersCount, plural, one {{followersCountDisplay} fylgjara} other {{followersCountDisplay} fylgjarar}} og {followingCount, plural, one {{followingCountDisplay} persón, sum tú fylgir} other {{followingCountDisplay} persónar, sum tú fylgir}}.",
  "domain_block_modal.you_will_lose_relationships": "Tú fer at missa allar fylgjarar og øll tey, tú fylgir á hesum ambætaranum.",
  "domain_block_modal.you_wont_see_posts": "Tú sært ongar postar ella boð frá brúkarum á hesum ambætara.",
  "domain_pill.activitypub_lets_connect": "Tað letur teg fáa samband og samvirka við fólki ikki bara á Mastodon, men á øðrum sosialum appum eisini.",
  "domain_pill.activitypub_like_language": "ActivityPub er málið, sum Mastodon tosar við onnur sosial netverk.",
  "domain_pill.server": "Ambætari",
  "domain_pill.their_handle": "Teirra hald:",
  "domain_pill.their_server": "Teirra talgilda heim, har allir teirra postar liva.",
  "domain_pill.their_username": "Teirra eyðmerki á teirra ambætara. Tað er møguligt at finna brúkarar við tí sama brúkaranavninum á ymiskum ambætarum.",
  "domain_pill.username": "Brúkaranavn",
  "domain_pill.whats_in_a_handle": "Hvat er í einum haldi?",
  "domain_pill.who_they_are": "Eftirsum at hald siga, hvør onkur er og hvar tey eru, so kanst tú samvirka við fólk á øllum <button>ActivityPub-riknum pallum</button>.",
  "domain_pill.who_you_are": "Av tí at tíni hald siga, hvør tú er og hvar tú eru, so kunnu onnur samvirka við teg á øllum <button>ActivityPub-riknum pallum</button>.",
  "domain_pill.your_handle": "Títt hald:",
  "domain_pill.your_server": "Títt talgilda heim, har allir tínir postar liva. Dámar tað ikki hendan? Flyt til ein annan ambætara tá tú hevur hug til tess og tak fylgjarar tínar við eisini.",
  "domain_pill.your_username": "Títt eyðmerki á hesum ambætaranum. Tað er møguligt at finna brúkarar við tí sama brúkaranavninum á ymiskum ambætarum.",
  "dropdown.empty": "Vel ein møguleika",
  "embed.instructions": "Fell hendan postin inní á tínum vevstaði við at taka avrit av koduni niðanfyri.",
  "embed.preview": "Soleiðis fer tað at síggja út:",
  "emoji_button.activity": "Virksemi",
  "emoji_button.clear": "Rudda",
  "emoji_button.custom": "Tillaga",
  "emoji_button.flags": "Fløgg",
  "emoji_button.food": "Matur & Drekka",
  "emoji_button.label": "Innset emoji",
  "emoji_button.nature": "Náttúra",
  "emoji_button.not_found": "Eingin kenslutekn funnin",
  "emoji_button.objects": "Lutir",
  "emoji_button.people": "Fólk",
  "emoji_button.recent": "Javnan nýtt",
  "emoji_button.search": "Leita...",
  "emoji_button.search_results": "Leitiúrslit",
  "emoji_button.symbols": "Ímyndir",
  "emoji_button.travel": "Ferðing og støð",
  "empty_column.account_hides_collections": "Hesin brúkarin hevur valt, at hesar upplýsingarnar ikki skulu vera tøkar",
  "empty_column.account_suspended": "Kontan gjørd óvirkin",
  "empty_column.account_timeline": "Einki uppslag her!",
  "empty_column.account_unavailable": "Vangin er ikki tøkur",
  "empty_column.blocks": "Tú hevur enn ikki bannað nakran brúkara.",
  "empty_column.bookmarked_statuses": "Tú hevur enn einki goymt uppslag. Tú tú goymir eitt uppslag, kemur tað her.",
  "empty_column.community": "Lokala tíðarlinjan er tóm. Skriva okkurt alment fyri at fáa boltin á rull!",
  "empty_column.direct": "Tú hevur ongar privatar umrøður enn. Tá tú sendir ella móttekur eina privata umrøðu, so verður hon sjónlig her.",
  "empty_column.disabled_feed": "Hendan rásin er gjørd óvirkin av ambætaraumsitarunum hjá tær.",
  "empty_column.domain_blocks": "Enn eru eingi blokeraði domenir.",
  "empty_column.explore_statuses": "Einki rák er beint nú. Royn aftur seinni!",
  "empty_column.favourited_statuses": "Tú hevur ongar yndispostar enn. Tá tú gevur einum posti yndismerki, so sært tú hann her.",
  "empty_column.favourites": "Eingin hevur givið hesum postinum yndismerki enn. Tá onkur ger, so sæst tað her.",
  "empty_column.follow_requests": "Tú hevur ongar umbønir um at verða fylgd/ur enn. Tá tú fær eina, so sæst hon her.",
  "empty_column.followed_tags": "Tú hevur ikki fylgt nøkrum frámerki enn. Tá tú ger tað, so síggjast tey her.",
  "empty_column.hashtag": "Einki er í hesum frámerkinum enn.",
  "empty_column.home": "Heima-tíðarlinjan hjá tær er tóm! Fylg fleiri fyri at fylla hana. {suggestions}",
  "empty_column.list": "Einki er í hesum listanum enn. Tá limir í hesum listanum posta nýggjar postar, so síggjast teir her.",
  "empty_column.mutes": "Tú hevur enn ikki doyvt nakran brúkara.",
  "empty_column.notification_requests": "Alt er klárt! Her er einki. Tá tú fært nýggjar fráboðanir, síggjast tær her sambært tínum stillingum.",
  "empty_column.notifications": "Tú hevur ongar fráboðanir enn. Tá onnur samskifta við teg, so sær tú fráboðaninar her.",
  "empty_column.public": "Einki er her! Skriva okkurt alment ella fylg brúkarum frá øðrum ambætarum fyri at fylla tilfar í",
  "empty_state.no_results": "Eingi úrslit",
  "error.no_hashtag_feed_access": "Melda til ella rita inn fyri at síggja og fylgja hesum frámerkinum.",
  "error.unexpected_crash.explanation": "Orsakað av einum feili í okkara kotu ella orsakað av at kagin hjá tær ikki er sambæriligur við skipanina, so bar ikki til at vísa hesa síðuna rætt.",
  "error.unexpected_crash.explanation_addons": "Hendan síðan kundi ikki vísast rætt. Orsøkin til feilin er sannlíkt vegna eina uppíbygging í kaganum hjá tær ella vegna amboð til sjálvvirkandi umseting.",
  "error.unexpected_crash.next_steps": "Royn at lesa síðuna inn av nýggjum. Hjálpir tað ikki, so kann vera, at tað ber til at brúka Mastodon við einum øðrum kaga ella við eini app.",
  "error.unexpected_crash.next_steps_addons": "Royn at gera tey óvirkin og lesa síðuna inn av nýggjum. Hjálpir tað ikki, so kann vera, at tað ber til at brúka Mastodon við einum øðrum kaga ella við eini app.",
  "errors.unexpected_crash.copy_stacktrace": "Avrita stakkaslóðina til setiborðið",
  "errors.unexpected_crash.report_issue": "Fráboða trupulleika",
  "explore.suggested_follows": "Fólk",
  "explore.title": "Vælumtókt",
  "explore.trending_links": "Tíðindi",
  "explore.trending_statuses": "Postar",
  "explore.trending_tags": "Frámerki",
  "featured_carousel.current": "<sr>Postur</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {festur postur} other {festir postar}}",
  "featured_carousel.slide": "Postur {current, number} av {max, number}",
  "featured_tags.more_items": "+{count}",
  "filter_modal.added.context_mismatch_explanation": "Hesin filturbólkurin viðvíkur ikki kontekstinum, sum tú hevur fingið atgongd til hendan postin. Ynskir tú at posturin verður filtreraður í hesum kontekstinum eisini, so er neyðugt at tú rættar filtrið.",
  "filter_modal.added.context_mismatch_title": "Ósamsvar við kontekst!",
  "filter_modal.added.expired_explanation": "Hesin filturbólkurin er útgingin, og tú mást broyta dagfestingina fyri at hann skal virka.",
  "filter_modal.added.expired_title": "Útgingið filtur!",
  "filter_modal.added.review_and_configure": "Far til {settings_link} fyri at kanna og stilla hendan filturbólkin.",
  "filter_modal.added.review_and_configure_title": "Filturstillingar",
  "filter_modal.added.settings_link": "síða við stillingum",
  "filter_modal.added.short_explanation": "Hesin posturin er lagdur afturat hesum filturbólkinum: {title}.",
  "filter_modal.added.title": "Filtur lagt afturat!",
  "filter_modal.select_filter.context_mismatch": "viðvíkur ikki hesum kontekstinum",
  "filter_modal.select_filter.expired": "útgingið",
  "filter_modal.select_filter.prompt_new": "Nýggjur bólkur: {name}",
  "filter_modal.select_filter.search": "Leita ella skapa",
  "filter_modal.select_filter.subtitle": "Brúka ein verandi bólk ella skapa ein nýggjan",
  "filter_modal.select_filter.title": "Filtrera hendan postin",
  "filter_modal.title.status": "Filtrera ein post",
  "filter_warning.matches_filter": "Samsvarar við filtrið “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Frá {count, plural, =0 {ongum} one {einum persóni} other {# persónum}}, sum tú kanska kennir",
  "filtered_notifications_banner.title": "Filtreraðar fráboðanir",
  "firehose.all": "Allar",
  "firehose.local": "Hesin ambætarin",
  "firehose.remote": "Aðrir ambætarar",
  "follow_request.authorize": "Veit myndugleika",
  "follow_request.reject": "Nokta",
  "follow_requests.unlocked_explanation": "Sjálvt um konta tín ikki er læst, so hugsa {domain} starvsfólkini, at tú kanska hevur hug at kanna umbønir um at fylgja frá hesum kontum við hond.",
  "follow_suggestions.curated_suggestion": "Val hjá ábyrgdarfólki",
  "follow_suggestions.dismiss": "Lat vera við at vísa",
  "follow_suggestions.featured_longer": "Vald burturúr av {domain} toyminum",
  "follow_suggestions.friends_of_friends_longer": "Vælumtókt millum fólk, sum tú fylgir",
  "follow_suggestions.hints.featured": "Hesin vangin er úrvaldur av toyminum handan {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Hesin vangin er vælumtóktur millum tey, tú fylgir.",
  "follow_suggestions.hints.most_followed": "Hesin vangin er ein av teimum, sum er mest fylgdur á {domain}.",
  "follow_suggestions.hints.most_interactions": "Nýliga hava nógv lagt merki til hendan vangan á {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Hesin vangin líkist teimum, sum tú nýliga hevur fylgt.",
  "follow_suggestions.personalized_suggestion": "Persónligt uppskot",
  "follow_suggestions.popular_suggestion": "Vælumtókt uppskot",
  "follow_suggestions.popular_suggestion_longer": "Vælumtókt á {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Líkist vangum, sum tú nýliga hevur fylgt",
  "follow_suggestions.view_all": "Vís øll",
  "follow_suggestions.who_to_follow": "Hvørji tú átti at fylgt",
  "followed_tags": "Fylgd frámerki",
  "followers.hide_other_followers": "Hesin brúkarin hevur valt ikki at lata hinar fylgjararnar vera sjónligar",
  "following.hide_other_following": "Hesin brúkarin hevur valt ikki at lata hini, sum tey fylgja, vera sjónligar",
  "footer.about": "Um",
  "footer.about_mastodon": "Um Mastodon",
  "footer.about_server": "Um {domain}",
  "footer.about_this_server": "Um",
  "footer.directory": "Vangaskrá",
  "footer.get_app": "Heinta appina",
  "footer.keyboard_shortcuts": "Knappasnarvegir",
  "footer.privacy_policy": "Privatlívspolitikkur",
  "footer.source_code": "Vís keldukotuna",
  "footer.status": "Støða",
  "footer.terms_of_service": "Tænastutreytir",
  "form_field.optional": "(valfrítt)",
  "generic.saved": "Goymt",
  "getting_started.heading": "At byrja",
  "hashtag.admin_moderation": "Lat umsjónarmarkamót upp fyri #{name}",
  "hashtag.browse": "Blaða gjøgnum postar í #{hashtag}",
  "hashtag.browse_from_account": "Blaða gjøgnum postar frá @{name} í #{hashtag}",
  "hashtag.column_header.tag_mode.all": "og {additional}",
  "hashtag.column_header.tag_mode.any": "ella {additional}",
  "hashtag.column_header.tag_mode.none": "uttan {additional}",
  "hashtag.column_settings.select.no_options_message": "Einki uppskot funnið",
  "hashtag.column_settings.select.placeholder": "Áset frámerki…",
  "hashtag.column_settings.tag_mode.all": "Øll hesi",
  "hashtag.column_settings.tag_mode.any": "Okkurt av hesum",
  "hashtag.column_settings.tag_mode.none": "Einki av hesum",
  "hashtag.column_settings.tag_toggle": "Legg frámerki afturat hesum teigi",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} luttakari} other {{counter} luttakarar}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} postur} other {{counter} postar}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} postur} other {{counter} postar}} í dag",
  "hashtag.feature": "Vís á vanga",
  "hashtag.follow": "Fylg frámerki",
  "hashtag.mute": "Doyv @#{hashtag}",
  "hashtag.unfeature": "Vís ikki á vanga",
  "hashtag.unfollow": "Gevst at fylgja frámerki",
  "hashtags.and_other": "…og {count, plural, other {# afturat}}",
  "hints.profiles.followers_may_be_missing": "Fylgjarar hjá hesum vanganum kunnu mangla.",
  "hints.profiles.follows_may_be_missing": "Listin við teimum, sum hesin vangin fylgir, kunnu mangla.",
  "hints.profiles.posts_may_be_missing": "Summir postar frá hesum vanganum kunnu mangla.",
  "hints.profiles.see_more_followers": "Sí fleiri fylgjarar á {domain}",
  "hints.profiles.see_more_follows": "Sí fleiri, ið viðkomandi fylgir, á {domain}",
  "hints.profiles.see_more_posts": "Sí fleiri postar á {domain}",
  "home.column_settings.show_quotes": "Vís siteringar",
  "home.column_settings.show_reblogs": "Vís stimbranir",
  "home.column_settings.show_replies": "Vís svar",
  "home.hide_announcements": "Fjal kunngerðir",
  "home.pending_critical_update.body": "Vinarliga dagfør Mastodon ambætaran hjá tær so skjótt sum møguligt!",
  "home.pending_critical_update.link": "Sí dagføringar",
  "home.pending_critical_update.title": "Kritisk trygdardagføring er tøk!",
  "home.show_announcements": "Vís kunngerðir",
  "ignore_notifications_modal.disclaimer": "Mastodon kann ikki upplýsa brúkarar um, at tú hevur latið sum um, at tú ikki hevur sæð teirra fráboðanir. At lata sum um, at tú ikki sær fráboðanir, forðar ikki, at boðini sjálv verða send.",
  "ignore_notifications_modal.filter_instead": "Filtrera ístaðin",
  "ignore_notifications_modal.filter_to_act_users": "Tú kanst framvegis góðtaka, avvísa og melda brúkarar",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrering ger tað lættari at sleppa undan møguligum misskiljingum",
  "ignore_notifications_modal.filter_to_review_separately": "Tú kanst kanna filtreraðar fráboðanir fyri seg",
  "ignore_notifications_modal.ignore": "Lat sum um tú ikki sær fráboðanir",
  "ignore_notifications_modal.limited_accounts_title": "Lat sum um tú ikki sær fráboðanir frá avmarkaðum kontum?",
  "ignore_notifications_modal.new_accounts_title": "Lat sum um tú ikki sær fráboðanir frá nýggjum kontum?",
  "ignore_notifications_modal.not_followers_title": "Lat sum um tú ikki sær fráboðanir frá fólki, sum ikki fylgja tær?",
  "ignore_notifications_modal.not_following_title": "Lat sum um tú ikki sær fráboðanir frá fólki, sum tú ikki fylgir?",
  "ignore_notifications_modal.private_mentions_title": "Lat sum um tú ikki sær fráboðanir frá óbiðnum privatum umrøðum?",
  "info_button.label": "Hjálp",
  "info_button.what_is_alt_text": "<h1>Hvat er alt tekstur?</h1> <p>Alt tekstur lýsir myndir fyri fólki, sum síggja illa, ella sum hava ringt net samband ella tey, sum vilja vita meira um samanhangin.</p> <p>Tú kanst bøta um atkomuna og fatanina hjá øllum við at skriva kláran, stuttan og objektivan alt tekst.</p> <ul> <li>Fanga týdningarmikil element</li> <li>Samanfata tekst í myndum</li> <li>Brúka reglubundnan setningsbygnað</li> <li>Lat vera við at siga ting upp í saman</li> <li>Fokusera á rák og høvuðsúrslit í kompleksum myndum (sosum diagrammir og kort)</li> </ul>",
  "interaction_modal.action": "Fyri at samvirka við postin hjá {name}, mást tú rita inn á Mastodon-ambætaranum, sum tú brúkar.",
  "interaction_modal.go": "Far",
  "interaction_modal.no_account_yet": "Hevur tú onga kontu enn?",
  "interaction_modal.on_another_server": "Á øðrum ambætara",
  "interaction_modal.on_this_server": "Á hesum ambætaranum",
  "interaction_modal.title": "Rita inn fyri at halda fram",
  "interaction_modal.username_prompt": "T.d. {example}",
  "intervals.full.days": "{number, plural, one {# dagur} other {# dagar}}",
  "intervals.full.hours": "{number, plural, one {# tími} other {# tímar}}",
  "intervals.full.minutes": "{number, plural, one {# minuttur} other {# minuttir}}",
  "keyboard_shortcuts.back": "Bakka",
  "keyboard_shortcuts.blocked": "Siggj listan við bannaðum brúkarum",
  "keyboard_shortcuts.boost": "Stimbra post",
  "keyboard_shortcuts.column": "Fá teig í miðdepilin",
  "keyboard_shortcuts.compose": "Fá skriviøkið í miðdeplin",
  "keyboard_shortcuts.description": "Frágreiðing",
  "keyboard_shortcuts.direct": "Lat teigin við privatum umrøðum upp",
  "keyboard_shortcuts.down": "Flyt niðureftir listanum",
  "keyboard_shortcuts.enter": "Opna uppslag",
  "keyboard_shortcuts.explore": "Lat rás við vælumtóktum postum upp",
  "keyboard_shortcuts.favourite": "Dáma post",
  "keyboard_shortcuts.favourites": "Lat listan av dámdum postum upp",
  "keyboard_shortcuts.federated": "Lat felags tíðslinju upp",
  "keyboard_shortcuts.heading": "Snarknappar",
  "keyboard_shortcuts.home": "Lat heimatíðarlinju upp",
  "keyboard_shortcuts.hotkey": "Snarknappur",
  "keyboard_shortcuts.legend": "Vís henda tekstin",
  "keyboard_shortcuts.load_more": "Fokusera á \"Tak meira niður\" knøttin",
  "keyboard_shortcuts.local": "Lat lokala tíðarlinju upp",
  "keyboard_shortcuts.mention": "Nevn rithøvund",
  "keyboard_shortcuts.muted": "Lat upp lista við doyvdum brúkarum",
  "keyboard_shortcuts.my_profile": "Lat vanga tín upp",
  "keyboard_shortcuts.notifications": "Lat fráboðanarteig upp",
  "keyboard_shortcuts.open_media": "Lat miðlar upp",
  "keyboard_shortcuts.pinned": "Lat lista yvir festar postar upp",
  "keyboard_shortcuts.profile": "Lat vangan hjá høvundinum upp",
  "keyboard_shortcuts.quote": "Sitera post",
  "keyboard_shortcuts.reply": "Svara posti",
  "keyboard_shortcuts.requests": "Lat lista við fylgjaraumbønum upp",
  "keyboard_shortcuts.search": "Fá leitibjálka í miðdepilin",
  "keyboard_shortcuts.spoilers": "Vís/fjal CW teig",
  "keyboard_shortcuts.start": "Lat \"kom í gongd\" teig upp",
  "keyboard_shortcuts.toggle_hidden": "Vís/fjal tekst handan CW",
  "keyboard_shortcuts.toggle_sensitivity": "Vís ella fjal innihald",
  "keyboard_shortcuts.toot": "Byrja nýggjan post",
  "keyboard_shortcuts.top": "Flyt til ovast á listanum",
  "keyboard_shortcuts.translate": "at umseta ein post",
  "keyboard_shortcuts.unfocus": "Tak skrivi-/leiti-økið úr miðdeplinum",
  "keyboard_shortcuts.up": "Flyt upp á listanum",
  "learn_more_link.got_it": "Eg skilji",
  "learn_more_link.learn_more": "Lær meira",
  "lightbox.close": "Lat aftur",
  "lightbox.next": "Fram",
  "lightbox.previous": "Aftur",
  "lightbox.zoom_in": "Suma til veruliga stødd",
  "lightbox.zoom_out": "Suma, so tað passar",
  "limited_account_hint.action": "Vís vangamynd kortini",
  "limited_account_hint.title": "Hesin vangin er fjaldur av kjakleiðarunum á {domain}.",
  "link_preview.author": "Av {name}",
  "link_preview.more_from_author": "Meira frá {name}",
  "link_preview.shares": "{count, plural, one {{counter} postur} other {{counter} postar}}",
  "lists.add_member": "Legg afturat",
  "lists.add_to_list": "Legg afturat lista",
  "lists.add_to_lists": "Legg {name} afturat lista",
  "lists.create": "Ger",
  "lists.create_a_list_to_organize": "Ger ein nýggjan lista til heimarásina hjá tær",
  "lists.create_list": "Ger lista",
  "lists.delete": "Strika lista",
  "lists.done": "Liðugt",
  "lists.edit": "Broyt lista",
  "lists.exclusive": "Fjal limir á heimarás",
  "lists.exclusive_hint": "Um onkur er á hesum listanum, so skulu tey fjalast á heimarásini, so tú sleppir undan at síggja postar teirra tvær ferðir.",
  "lists.find_users_to_add": "Finn brúkarar at leggja afturat",
  "lists.list_members_count": "{count, plural, one {# limur} other {# limir}}",
  "lists.list_name": "Listanavn",
  "lists.new_list_name": "Nýtt listanavn",
  "lists.no_lists_yet": "Ongir listar enn.",
  "lists.no_members_yet": "Eingir limir enn.",
  "lists.no_results_found": "Eingi úrslit funnin.",
  "lists.remove_member": "Burturbein",
  "lists.replies_policy.followed": "Øllum fylgdum brúkarum",
  "lists.replies_policy.list": "Listalimunum",
  "lists.replies_policy.none": "Eingin",
  "lists.save": "Goym",
  "lists.search": "Leita",
  "lists.show_replies_to": "Írokna svar frá limum á listanum til",
  "load_pending": "{count, plural, one {# nýtt evni} other {# nýggj evni}}",
  "loading_indicator.label": "Innlesur…",
  "media_gallery.hide": "Fjal",
  "moved_to_account_banner.text": "Konta tín {disabledAccount} er í løtuni óvirkin, tí tú flutti til {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Fjal boð",
  "mute_modal.hide_options": "Fjal valmøguleikar",
  "mute_modal.indefinite": "Inntil eg tendri tey aftur",
  "mute_modal.show_options": "Vís valmøguleikar",
  "mute_modal.they_can_mention_and_follow": "Tey kunnu bæði nevna og fylgja tær, men tú sært ikki tey.",
  "mute_modal.they_wont_know": "Tey vita ikki, at tey eru sløkt.",
  "mute_modal.title": "Sløkk brúkara?",
  "mute_modal.you_wont_see_mentions": "Tú sært ikki postar, sum nevna tey.",
  "mute_modal.you_wont_see_posts": "Tey síggja framvegis tínar postar, men tú sært ikki teirra.",
  "navigation_bar.about": "Um",
  "navigation_bar.account_settings": "Loyniorð og trygd",
  "navigation_bar.administration": "Umsiting",
  "navigation_bar.advanced_interface": "Lat upp í framkomnum vevmarkamóti",
  "navigation_bar.automated_deletion": "Sjálvvirkandi striking av postum",
  "navigation_bar.blocks": "Bannaðir brúkarar",
  "navigation_bar.bookmarks": "Goymd",
  "navigation_bar.direct": "Privatar umrøður",
  "navigation_bar.domain_blocks": "Bannað økisnøvn",
  "navigation_bar.favourites": "Dámdir postar",
  "navigation_bar.filters": "Doyvd orð",
  "navigation_bar.follow_requests": "Umbønir um at fylgja",
  "navigation_bar.followed_tags": "Fylgd frámerki",
  "navigation_bar.follows_and_followers": "Fylgd og fylgjarar",
  "navigation_bar.import_export": "Innflyt og útflyt",
  "navigation_bar.lists": "Listar",
  "navigation_bar.live_feed_local": "Beinleiðis rásir (lokalar)",
  "navigation_bar.live_feed_public": "Beinleiðis rásir (almennar)",
  "navigation_bar.logout": "Rita út",
  "navigation_bar.moderation": "Umsjón",
  "navigation_bar.more": "Meira",
  "navigation_bar.mutes": "Doyvdir brúkarar",
  "navigation_bar.opened_in_classic_interface": "Postar, kontur og aðrar serstakar síður verða - um ikki annað er ásett - latnar upp í klassiska vev-markamótinum.",
  "navigation_bar.preferences": "Stillingar",
  "navigation_bar.privacy_and_reach": "Privatlív og skotmál",
  "navigation_bar.search": "Leita",
  "navigation_bar.search_trends": "Leita / Rák",
  "navigation_panel.collapse_followed_tags": "Minka valmynd við fylgdum frámerkjum",
  "navigation_panel.collapse_lists": "Minka listavalmynd",
  "navigation_panel.expand_followed_tags": "Víðka valmynd við fylgdum frámerkjum",
  "navigation_panel.expand_lists": "Víðka listavalmynd",
  "not_signed_in_indicator.not_signed_in": "Tú mást rita inn fyri at fáa atgongd til hetta tilfarið.",
  "notification.admin.report": "{name} hevur meldað {target}",
  "notification.admin.report_account": "{name} meldaði {count, plural, one {ein post} other {# postar}} frá {target} fyri {category}",
  "notification.admin.report_account_other": "{name} meldaði {count, plural, one {ein post} other {# postar}} frá {target}",
  "notification.admin.report_statuses": "{name} meldaði {target} fyri {category}",
  "notification.admin.report_statuses_other": "{name} meldaði {target}",
  "notification.admin.sign_up": "{name} meldaði seg til",
  "notification.admin.sign_up.name_and_others": "{name} og {count, plural, one {# annar/onnur} other {# onnur}} teknaðu seg",
  "notification.annual_report.message": "Títt {year} #Wrapstodon bíðar! Avdúka hæddarpunktini og minniligu løturnar á Mastodon!",
  "notification.annual_report.view": "Sí #Wrapstodon",
  "notification.favourite": "{name} dámdi postin hjá tær",
  "notification.favourite.name_and_others_with_link": "{name} og <a>{count, plural, one {# annar/onnur} other {# onnur}}</a> yndisfrámerktu postin hjá tær",
  "notification.favourite_pm": "{name} yndismerkti tína privatu umrøðu",
  "notification.favourite_pm.name_and_others_with_link": "{name} og <a>{count, plural, one {# annar yndismerkti} other {# onnur yndismerktu}}</a> tína privatu umrøðu",
  "notification.follow": "{name} fylgdi tær",
  "notification.follow.name_and_others": "{name} og <a>{count, plural, one {# annar/onnur} other {# onnur}}</a> fylgdu tær",
  "notification.follow_request": "{name} biður um at fylgja tær",
  "notification.follow_request.name_and_others": "{name} og {count, plural, one {# annar/onnur} other {# onnur}} hava biðið um at fylgja tær",
  "notification.label.mention": "Umrøða",
  "notification.label.private_mention": "Privat umrøða",
  "notification.label.private_reply": "Privat svar",
  "notification.label.quote": "{name} siteraði postin hjá tær",
  "notification.label.reply": "Svara",
  "notification.mention": "Umrøð",
  "notification.mentioned_you": "{name} nevndi teg",
  "notification.moderation-warning.learn_more": "Lær meira",
  "notification.moderation_warning": "Tú hevur móttikið eina umsjónarávaring",
  "notification.moderation_warning.action_delete_statuses": "Onkrir av tínum postum eru strikaðir.",
  "notification.moderation_warning.action_disable": "Konta tín er gjørd óvirkin.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Nakrir av postum tínum eru merktir sum viðkvæmir.",
  "notification.moderation_warning.action_none": "Konta tín hevur móttikið eina umsjónarávaring.",
  "notification.moderation_warning.action_sensitive": "Postar tínir verða merktir sum viðkvæmir frá nú av.",
  "notification.moderation_warning.action_silence": "Konta tín er avmarkað.",
  "notification.moderation_warning.action_suspend": "Konta tín er ógildað.",
  "notification.own_poll": "Tín atkvøðugreiðsla er endað",
  "notification.poll": "Ein atkvøðugreiðsla, har tú atkvøddi, er endað",
  "notification.quoted_update": "{name} rættaði ein post, sum tú hevur siterað",
  "notification.reblog": "{name} stimbraði tín post",
  "notification.reblog.name_and_others_with_link": "{name} og <a>{count, plural, one {# annar/onnur} other {# onnur}}</a> framhevjaðu tín post",
  "notification.relationships_severance_event": "Mist sambond við {name}",
  "notification.relationships_severance_event.account_suspension": "Ein umsitari frá {from} hevur gjørt {target} óvirkna, sum merkir, at tú ikki kanst móttaka dagføringar ella virka saman við teimum longur.",
  "notification.relationships_severance_event.domain_block": "Ein umsitari frá {from} hevur blokerað {target}, íroknað {followersCount} av tínum fylgjarum og {followingCount, plural, one {# kontu} other {# kontur}}, sum tú fylgir.",
  "notification.relationships_severance_event.learn_more": "Lær meira",
  "notification.relationships_severance_event.user_domain_block": "Tú hevur blokerað {target}, strikað {followersCount} av tínum fylgjarum og {followingCount, plural, one {# kontu} other {# kontur}}, sum tú fylgir.",
  "notification.status": "{name} hevur júst postað",
  "notification.update": "{name} rættaði ein post",
  "notification_requests.accept": "Góðtak",
  "notification_requests.accept_multiple": "{count, plural, one {Góðtak # umbøn…} other {Góðtak # umbønir…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Góðtak umbøn} other {Góðtak umbønir}}",
  "notification_requests.confirm_accept_multiple.message": "Tú er í ferð við at góðtaka {count, plural, one {eina fráboðanarumbøn} other {# fráboðanarumbønir}}. Er tú vís/ur í, at tú vil halda fram?",
  "notification_requests.confirm_accept_multiple.title": "Góðtak fráboðanarumbønir?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Avvís umbøn} other {Avvís umbønir}}",
  "notification_requests.confirm_dismiss_multiple.message": "Tú er í ferð við at avvísa {count, plural, one {eina fráboðanarumbøn} other {# fráboðanarumbønir}}. Tað verður ikki lætt hjá tær at fáa fatur á {count, plural, one {henni} other {teimum}} aftur. Er tú vís/ur í at tú vil halda fram?",
  "notification_requests.confirm_dismiss_multiple.title": "Avvís fráboðanarumbønir?",
  "notification_requests.dismiss": "Avvís",
  "notification_requests.dismiss_multiple": "{count, plural, one {Avvís # umbøn…} other {Avvís # umbønir…}}",
  "notification_requests.edit_selection": "Rætta",
  "notification_requests.exit_selection": "Liðugt",
  "notification_requests.explainer_for_limited_account": "Fráboðanir frá hesi kontuni eru filtreraðar burtur, tí kontan er avmarkað av einum umsjónarfólki.",
  "notification_requests.explainer_for_limited_remote_account": "Fráboðanir frá hesi kontuni eru filtreraðar burtur, tí kontan ella ambætarin hjá kontuni eru avmarkaði av einum umsjónarfólki.",
  "notification_requests.maximize": "Mesta",
  "notification_requests.minimize_banner": "Ger merkið við filtreraðum fráboðanum lítið",
  "notification_requests.notifications_from": "Fráboðanir frá {name}",
  "notification_requests.title": "Filtreraðar fráboðanir",
  "notification_requests.view": "Vís fráboðanir",
  "notifications.clear": "Rudda fráboðanir",
  "notifications.clear_confirmation": "Ert tú vís/ur í, at tú vilt strika allar tínar fráboðanir?",
  "notifications.clear_title": "Rudda fráboðanir?",
  "notifications.column_settings.admin.report": "Nýggjar fráboðanir:",
  "notifications.column_settings.admin.sign_up": "Nýggjar tilmeldingar:",
  "notifications.column_settings.alert": "Skriviborðsfráboðanir",
  "notifications.column_settings.favourite": "Dámdir postar:",
  "notifications.column_settings.filter_bar.advanced": "Vís allar bólkar",
  "notifications.column_settings.filter_bar.category": "Skjótfilturbjálki",
  "notifications.column_settings.follow": "Nýggir fylgjarar:",
  "notifications.column_settings.follow_request": "Nýggjar umbønir um at fylgja:",
  "notifications.column_settings.group": "Bólkur",
  "notifications.column_settings.mention": "Umrøður:",
  "notifications.column_settings.poll": "Úrslit frá atkvøðugreiðslu:",
  "notifications.column_settings.push": "Trýstifráboðanir",
  "notifications.column_settings.quote": "Sitatir:",
  "notifications.column_settings.reblog": "Stimbranir:",
  "notifications.column_settings.show": "Vís í teigi",
  "notifications.column_settings.sound": "Spæl ljóð",
  "notifications.column_settings.status": "Nýggir postar:",
  "notifications.column_settings.unread_notifications.category": "Ólisnar fráboðanir",
  "notifications.column_settings.unread_notifications.highlight": "Hálýs ólisnar fráboðanir",
  "notifications.column_settings.update": "Rættingar:",
  "notifications.filter.all": "Øll",
  "notifications.filter.boosts": "Stimbranir",
  "notifications.filter.favourites": "Dámdir postar",
  "notifications.filter.follows": "Fylgir",
  "notifications.filter.mentions": "Umrøður",
  "notifications.filter.polls": "Úrslit av atkvøðugreiðslu",
  "notifications.filter.statuses": "Dagføringar frá fólki, tú kennur",
  "notifications.grant_permission": "Gev lovi.",
  "notifications.group": "{count} fráboðanir",
  "notifications.mark_as_read": "Merk allar fráboðanir sum lisnar",
  "notifications.permission_denied": "Skriviborðsfráboðanir eru ikki tøkar tí at ein kaga-umbøn áður bleiv noktað",
  "notifications.permission_denied_alert": "Tað ber ikki til at sláa skriviborðsfráboðanir til, tí at kagarættindi áður eru noktaði",
  "notifications.permission_required": "Skriviborðsfráboðanir eru ikki tøkar, tí at neyðugu rættindini eru ikki latin.",
  "notifications.policy.accept": "Góðtak",
  "notifications.policy.accept_hint": "Vís í fráboðanum",
  "notifications.policy.drop": "Lat sum um tú ikki sær",
  "notifications.policy.drop_hint": "Send út í tóman heim, soleiðis at tað aldrin sæst aftur",
  "notifications.policy.filter": "Filtrera",
  "notifications.policy.filter_hint": "Send til filtreraðan fráboðanar-innbakka",
  "notifications.policy.filter_limited_accounts_hint": "Avmarkað av umsjónarfólkunum á ambætaranum",
  "notifications.policy.filter_limited_accounts_title": "Avmarkaðar kontur",
  "notifications.policy.filter_new_accounts.hint": "Stovnaðar {days, plural, one {seinasta dagin} other {seinastu # dagarnar}}",
  "notifications.policy.filter_new_accounts_title": "Nýggjar kontur",
  "notifications.policy.filter_not_followers_hint": "Íroknað fólk, sum hava fylgt tær styttri enn {days, plural, one {ein dag} other {# dagar}}",
  "notifications.policy.filter_not_followers_title": "Fólk, sum ikki fylgja tær",
  "notifications.policy.filter_not_following_hint": "Til tú góðkennir tey manuelt",
  "notifications.policy.filter_not_following_title": "Fólk, sum tú ikki fylgir",
  "notifications.policy.filter_private_mentions_hint": "Filtreraði, uttan so at tað er í svari til tínar egnu nevningar ella um tú fylgir sendaranum",
  "notifications.policy.filter_private_mentions_title": "Óbidnar privatar umrøður",
  "notifications.policy.title": "Stýr fráboðanir frá…",
  "notifications_permission_banner.enable": "Ger skriviborðsfráboðanir virknar",
  "notifications_permission_banner.how_to_control": "Ger skriviborðsfráboðanir virknar fyri at móttaka fráboðanir, tá Mastodon ikki er opið. Tá tær eru gjørdar virknar, kanst tú stýra, hvørji sløg av samvirkni geva skriviborðsfráboðanir. Hetta umvegis {icon} knøttin omanfyri.",
  "notifications_permission_banner.title": "Miss einki",
  "onboarding.follows.back": "Aftur",
  "onboarding.follows.empty": "Tíverri kunnu eingi úrslit vísast beint nú. Tú kanst royna at brúka leiting ella at kaga gjøgnum Rannsaka síðuna fyri at finna fólk at fylgja - ella royna aftur seinni.",
  "onboarding.follows.search": "Leita",
  "onboarding.follows.title": "Fylg fólki fyri at koma í gongd",
  "onboarding.profile.discoverable": "Ger tað møguligt hjá øðrum at finna vangan hjá mær",
  "onboarding.profile.discoverable_hint": "Tá tú játtar at onnur skulu kunna finna teg á Mastodon, so kann henda, at postar tínir síggjast í leitiúrslitum og rákum, og vangin hjá tær kann vera skotin upp fyri fólki við áhugamálum sum minna um tíni.",
  "onboarding.profile.display_name": "Navn, sum skal vísast",
  "onboarding.profile.display_name_hint": "Títt fulla navn ella títt stuttliga navn…",
  "onboarding.profile.note": "Ævilýsing",
  "onboarding.profile.note_hint": "Tú kanst @umrøða onnur fólk ella #frámerki…",
  "onboarding.profile.title": "Vangauppsetan",
  "onboarding.profile.upload_avatar": "Legg vangamynd upp",
  "onboarding.profile.upload_header": "Legg vangahøvd upp",
  "password_confirmation.exceeds_maxlength": "Loyniorðsváttanin er longri enn mest loyvda loyniorðslongd",
  "password_confirmation.mismatching": "Loyniorðsváttanin passar ikki til",
  "picture_in_picture.restore": "Legg hana aftur",
  "poll.closed": "Endað",
  "poll.refresh": "Endurles",
  "poll.reveal": "Sí úrslit",
  "poll.total_people": "{count, plural, one {# persónur} other {# persónar}}",
  "poll.total_votes": "{count, plural, one {# atkvøða} other {# atkvøður}}",
  "poll.vote": "Atkvøð",
  "poll.voted": "Hetta atkvøddi tú",
  "poll.votes": "{votes, plural, one {# atkvøða} other {# atkvøður}}",
  "poll_button.add_poll": "Legg atkvøðugreiðslu afturat",
  "poll_button.remove_poll": "Strika atkvøðugreiðslu",
  "privacy.change": "Broyt privatverju av posti",
  "privacy.direct.long": "Øll, sum eru nevnd í postinum",
  "privacy.direct.short": "Privat umrøða",
  "privacy.private.long": "Einans tey, ið fylgja tær",
  "privacy.private.short": "Fylgjarar",
  "privacy.public.long": "Øll í og uttanfyri Mastodon",
  "privacy.public.short": "Alment",
  "privacy.quote.anyone": "{visibility}, siteringar loyvdar",
  "privacy.quote.disabled": "{visibility}, siteringar óvirknar",
  "privacy.quote.limited": "{visibility}, siteringar avmarkaðar",
  "privacy.unlisted.additional": "Hetta er júst sum almenn, tó verður posturin ikki vístur í samtíðarrásum ella frámerkjum, rannsakan ella Mastodon leitingum, sjálvt um valið er galdandi fyri alla kontuna.",
  "privacy.unlisted.long": "Fjalt frá Mastodon leitiúrslitum og vælumtóktum og almennum tíðarlinjum",
  "privacy.unlisted.short": "Stillur almenningur",
  "privacy_policy.last_updated": "Seinast dagført {date}",
  "privacy_policy.title": "Privatlívspolitikkur",
  "quote_error.edit": "Sitatir kunnu ikki leggjast afturat tá tú rættar ein post.",
  "quote_error.poll": "Tað er ikki loyvt at sitera spurnarkanningar.",
  "quote_error.private_mentions": "Sitering er ikki loyvd við beinleiðis umrøðum.",
  "quote_error.quote": "Bara ein sitering er loyvd í senn.",
  "quote_error.unauthorized": "Tú hevur ikki rættindi at sitera hendan postin.",
  "quote_error.upload": "Sitering er ikki loyvd um miðlar eru viðheftir.",
  "recommended": "Viðmælt",
  "refresh": "Endurles",
  "regeneration_indicator.please_stand_by": "Bíða við.",
  "regeneration_indicator.preparing_your_home_feed": "Fyrireiki heimarásina hjá tær…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dagur} other {# dagar}} síðani",
  "relative_time.full.hours": "{number, plural, one {# tími} other {# tímar}} síðani",
  "relative_time.full.just_now": "júst nú",
  "relative_time.full.minutes": "{number, plural, one {# minuttur} other {# minuttir}} síðani",
  "relative_time.full.seconds": "{number, plural, one {# sekund} other {# sekund}} síðani",
  "relative_time.hours": "{number}t",
  "relative_time.just_now": "nú",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "í dag",
  "remove_quote_hint.button_label": "Eg skilji",
  "remove_quote_hint.message": "Tú kanst gera tað frá {icon} valmyndini.",
  "remove_quote_hint.title": "Vilt tú strika siteraða postin hjá tær?",
  "reply_indicator.attachments": "{count, plural, one {# viðfesti} other {# viðfesti}}",
  "reply_indicator.cancel": "Ógilda",
  "reply_indicator.poll": "Atkvøðugreiðsla",
  "report.block": "Blokera",
  "report.block_explanation": "Tú fer ikki at síggja postarnar hjá teimum. Tey kunnu ikki síggja tínar postar ella fylgja tær. Tey síggja, at tey eru blokeraði.",
  "report.categories.legal": "Løgfrøðisligt",
  "report.categories.other": "Onnur",
  "report.categories.spam": "Ruskpostur",
  "report.categories.violation": "Innihaldið brýtur eina ella fleiri ambætarareglur",
  "report.category.subtitle": "Vel besta boðið",
  "report.category.title": "Fortel okkum, hvat hendir við hesum {type}",
  "report.category.title_account": "vangi",
  "report.category.title_status": "postinum",
  "report.close": "Liðugt",
  "report.collection_comment": "Hví vilt tú melda hetta savnið?",
  "report.comment.title": "Er nakað annað, sum tú heldur, at vit áttu at vitað?",
  "report.forward": "Víðarisend til {target}",
  "report.forward_hint": "Kontan er frá einum øðrum ambætara. Send eitt dulnevnt avrit av meldingini hagar eisini?",
  "report.mute": "Doyv",
  "report.mute_explanation": "Tú fert ikki at síggja teirra uppsløg. Tey kunnu framvegis fylgja tær og síggja tíni uppsløg og fara ikki at vita av, at tey eru doyvd.",
  "report.next": "Næsta",
  "report.placeholder": "Aðrar viðmerkingar",
  "report.reasons.dislike": "Mær dámar tað ikki",
  "report.reasons.dislike_description": "Tú ynskir ikki at síggja hetta",
  "report.reasons.legal": "Tað er ólógligt",
  "report.reasons.legal_description": "Tú trýrt at tað stríðir ímóti lógini í tínum landi ella landinum, har ambætarin hjá tær er",
  "report.reasons.other": "Tað er nakað annað",
  "report.reasons.other_description": "Evnið hóskar ikki inn í aðrar bólkar",
  "report.reasons.spam": "Tað er ruskpostur",
  "report.reasons.spam_description": "Meinfýsin leinki, følsk hugbinding ella endurtakandi svar",
  "report.reasons.violation": "Tað brýtur ambætarareglur",
  "report.reasons.violation_description": "Tú er varug/ur við, at tað brýtur ávísar reglur",
  "report.rules.subtitle": "Vel alt viðkomandi",
  "report.rules.title": "Hvørjar reglur verða brotnar?",
  "report.statuses.subtitle": "Vel alt viðkomandi",
  "report.statuses.title": "Eru nakrir postar, sum stuðla uppundir hesa meldingina?",
  "report.submission_error": "Meldingin kundi ikki fráboðast",
  "report.submission_error_details": "Vinarliga eftirkanna netsambandið og royn aftur seinni.",
  "report.submit": "Send inn",
  "report.target": "Meldi {target}",
  "report.thanks.take_action": "Her eru tínir møguleikar fyri at stýra, hvat tú sær á Mastodon:",
  "report.thanks.take_action_actionable": "Meðan vit kanna hetta, kanst tú taka hóskandi fyrivarni móti @{name}:",
  "report.thanks.title": "Vil tú ikki síggja hetta?",
  "report.thanks.title_actionable": "Takk fyri meldingina; vit kanna tað nærri.",
  "report.unfollow": "Gevst at fylgja @{name}",
  "report.unfollow_explanation": "Tú fylgir hesi kontuni. Gevst at fylgja henni, um tú ikki longur ynskir at síggja postarnar á heimarásini hjá tær.",
  "report_notification.attached_statuses": "{count, plural, one {{count} postur atknýttur} other {{count} postar atknýttir}}",
  "report_notification.categories.legal": "Løgfrøðisligt",
  "report_notification.categories.legal_sentence": "ólógligt innihald",
  "report_notification.categories.other": "Aðrir",
  "report_notification.categories.other_sentence": "aðrir",
  "report_notification.categories.spam": "Ruskpostur",
  "report_notification.categories.spam_sentence": "ruskpostur",
  "report_notification.categories.violation": "Brotin regla",
  "report_notification.categories.violation_sentence": "brot á reglu",
  "report_notification.open": "Opna melding",
  "search.clear": "Nullstilla leiting",
  "search.no_recent_searches": "Ongar nýggjar leitingar",
  "search.placeholder": "Leita",
  "search.quick_action.account_search": "Vangar, ið samsvara {x}",
  "search.quick_action.go_to_account": "Far til vanga {x}",
  "search.quick_action.go_to_hashtag": "Far til frámerki {x}",
  "search.quick_action.open_url": "Lat URL upp í Mastodon",
  "search.quick_action.status_search": "Postar, ið samsvara {x}",
  "search.search_or_paste": "Leita ella set URL inn",
  "search_popout.full_text_search_disabled_message": "Ikki tøkt á {domain}.",
  "search_popout.full_text_search_logged_out_message": "Einans tøkt um innritað er.",
  "search_popout.language_code": "ISO málkoda",
  "search_popout.options": "Leitimøguleikar",
  "search_popout.quick_actions": "Skjótar atgerðir",
  "search_popout.recent": "Nýggjar leitingar",
  "search_popout.specific_date": "ávís dagfesting",
  "search_popout.user": "brúkari",
  "search_results.accounts": "Vangar",
  "search_results.all": "Alt",
  "search_results.hashtags": "Frámerki",
  "search_results.no_results": "Eingi úrslit.",
  "search_results.no_search_yet": "Royn at leita eftir postum, vangum ella frámerkjum.",
  "search_results.see_all": "Sí øll",
  "search_results.statuses": "Postar",
  "search_results.title": "Leita eftir \"{q}\"",
  "server_banner.about_active_users": "Fólk, sum hava brúkt hendan ambætaran seinastu 30 dagarnar (mánaðarligir virknir brúkarar)",
  "server_banner.active_users": "virknir brúkarar",
  "server_banner.administered_by": "Umsitari:",
  "server_banner.is_one_of_many": "{domain} er ein av nógvum óheftum Mastodon ambætarum, sum tú kanst brúka at luttaka í fediversinum.",
  "server_banner.server_stats": "Ambætarahagtøl:",
  "sign_in_banner.create_account": "Stovna kontu",
  "sign_in_banner.follow_anyone": "Fylg ein og hvønn í fediversinum og síggj alt í tíðarrøð. Ongar algoritmur, ongar lýsingar og einki klikkbeit í eygsjón.",
  "sign_in_banner.mastodon_is": "Mastodon er best mátin at fylgja við í tí, sum hendir.",
  "sign_in_banner.sign_in": "Rita inn",
  "sign_in_banner.sso_redirect": "Rita inn ella Skráset teg",
  "skip_links.hotkey": "<span>Snarknappur</span> {hotkey}",
  "skip_links.skip_to_content": "Far til høvuðsinnihald",
  "skip_links.skip_to_navigation": "Far til høvuðs-navigatión",
  "status.admin_account": "Lat kjakleiðaramarkamót upp fyri @{name}",
  "status.admin_domain": "Lat umsjónarmarkamót upp fyri {domain}",
  "status.admin_status": "Lat hendan postin upp í kjakleiðaramarkamótinum",
  "status.all_disabled": "Stimbranir og sitatir eru gjørd óvirkin",
  "status.block": "Blokera @{name}",
  "status.bookmark": "Goym",
  "status.cancel_reblog_private": "Strika stimbran",
  "status.cannot_quote": "Tú hevur ikki loyvi at sitera hendan postin",
  "status.cannot_reblog": "Tað ber ikki til at stimbra hendan postin",
  "status.contains_quote": "Inniheldur sitat",
  "status.context.loading": "Tekur fleiri svar niður",
  "status.context.loading_error": "Fekk ikki tikið nýggj svar niður",
  "status.context.loading_success": "Nýggj svar tikin niður",
  "status.context.more_replies_found": "Fleiri svar funnin",
  "status.context.retry": "Royn aftur",
  "status.context.show": "Vís",
  "status.continued_thread": "Framhaldandi tráður",
  "status.copy": "Kopiera leinki til postin",
  "status.delete": "Strika",
  "status.delete.success": "Postur strikaður",
  "status.detailed_status": "Útgreinað samrøðusýni",
  "status.direct": "Umrøð @{name} privat",
  "status.direct_indicator": "Privat umrøða",
  "status.edit": "Rætta",
  "status.edited": "Seinast broytt {date}",
  "status.edited_x_times": "Rættað {count, plural, one {{count} ferð} other {{count} ferð}}",
  "status.embed": "Fá kodu at seta inn",
  "status.favourite": "Dámdur postur",
  "status.favourites_count": "{count, plural, one {{counter} yndispostur} other {{counter} yndispostar}}",
  "status.filter": "Filtrera hendan postin",
  "status.history.created": "{name} stovnað {date}",
  "status.history.edited": "{name} rættað {date}",
  "status.load_more": "Tak meira niður",
  "status.media.open": "Klikka fyri at lata upp",
  "status.media.show": "Klikka fyri at vísa",
  "status.media_hidden": "Miðil fjaldur",
  "status.mention": "Nevn @{name}",
  "status.more": "Meira",
  "status.mute": "Doyv @{name}",
  "status.mute_conversation": "Doyv samrøðu",
  "status.open": "Víðka henda postin",
  "status.pin": "Ger fastan í vangan",
  "status.quote": "Sitat",
  "status.quote.cancel": "Ógilda sitat",
  "status.quote_error.blocked_account_hint.title": "Hesin posturin er fjaldur, tí tú hevur blokerað @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Hesin posturin er fjaldur, tí tú hevur blokerað @{domain}.",
  "status.quote_error.filtered": "Eitt av tínum filtrum fjalir hetta",
  "status.quote_error.limited_account_hint.action": "Vís kortini",
  "status.quote_error.limited_account_hint.title": "Hendan kontan er fjald av kjakleiðarunum á {domain}.",
  "status.quote_error.muted_account_hint.title": "Hesin posturin er fjaldur, tí tú hevur doyvt @{name}.",
  "status.quote_error.not_available": "Postur ikki tøkur",
  "status.quote_error.pending_approval": "Postur bíðar",
  "status.quote_error.pending_approval_popout.body": "Á Mastodon kanst tú avgera, um onkur kann sitera teg. Hesin posturin bíðar eftir góðkenning frá upprunahøvundinum.",
  "status.quote_error.revoked": "Posturin burturbeindur av høvundinum",
  "status.quote_followers_only": "Bara fylgjarar kunnu sitera hendan postin",
  "status.quote_manual_review": "Høvundurin fer at eftirkanna manuelt",
  "status.quote_noun": "Sitat",
  "status.quote_policy_change": "Broyt hvør kann sitera",
  "status.quote_post_author": "Siteraði ein post hjá @{name}",
  "status.quote_private": "Privatir postar kunnu ikki siterast",
  "status.quotes.empty": "Eingin hevur siterað hendan postin enn. Tá onkur siterar postin, verður hann sjónligur her.",
  "status.quotes.local_other_disclaimer": "Sitatir, sum eru avvíst av høvundanum, verða ikki víst.",
  "status.quotes.remote_other_disclaimer": "Einans sitatir frá {domain} vera garanterað víst her. Sitatir, sum eru avvíst av høvundanum, verða ikki víst.",
  "status.quotes_count": "{count, plural, one {{counter} sitat} other {{counter} sitat}}",
  "status.read_more": "Les meira",
  "status.reblog": "Stimbra",
  "status.reblog_or_quote": "Stimbra ella sitera",
  "status.reblog_private": "Deil aftur við tínum fylgjarum",
  "status.reblogged_by": "{name} stimbrað",
  "status.reblogs.empty": "Eingin hevur stimbrað hendan postin enn. Tá onkur stimbrar postin, verður hann sjónligur her.",
  "status.reblogs_count": "{count, plural, one {{counter} stimbran} other {{counter} stimbranir}}",
  "status.redraft": "Strika & ger nýggja kladdu",
  "status.remove_bookmark": "Gloym",
  "status.remove_favourite": "Strika í yndismerkjum",
  "status.remove_quote": "Burturbein",
  "status.replied_in_thread": "Svaraði í tráðnum",
  "status.replied_to": "Svaraði {name}",
  "status.reply": "Svara",
  "status.replyAll": "Svara tráðnum",
  "status.report": "Melda @{name}",
  "status.request_quote": "Fyrispurningur um at sitera",
  "status.revoke_quote": "Strika postin hjá mær frá postinum hjá @{name}",
  "status.sensitive_warning": "Viðkvæmt tilfar",
  "status.share": "Deil",
  "status.show_less_all": "Vís øllum minni",
  "status.show_more_all": "Vís øllum meira",
  "status.show_original": "Vís upprunaliga",
  "status.title.with_attachments": "{user} postaði {attachmentCount, plural, one {eitt viðhefti} other {{attachmentCount} viðhefti}}",
  "status.translate": "Umset",
  "status.translated_from_with": "Umsett frá {lang} við {provider}",
  "status.uncached_media_warning": "Undanvísing ikki tøk",
  "status.unmute_conversation": "Strika doyving av samrøðu",
  "status.unpin": "Loys frá vanga",
  "subscribed_languages.lead": "Eftir broytingina fara einans postar á valdum málum at síggjast á tíni heimarás og á tínum listatíðarlinjum. Vel ongi fyri at fáa postar á øllum málum.",
  "subscribed_languages.save": "Goym broytingar",
  "subscribed_languages.target": "Broyt haldaramál fyri {target}",
  "tabs_bar.home": "Heim",
  "tabs_bar.menu": "Valmynd",
  "tabs_bar.notifications": "Fráboðanir",
  "tabs_bar.publish": "Nýggjur postur",
  "tabs_bar.search": "Leita",
  "tag.remove": "Burturbein",
  "terms_of_service.effective_as_of": "Galdandi frá {date}",
  "terms_of_service.title": "Tænastutreytir",
  "terms_of_service.upcoming_changes_on": "Komandi broytingar {date}",
  "time_remaining.days": "{number, plural, one {# dagur} other {# dagar}} eftir",
  "time_remaining.hours": "{number, plural, one {# tími} other {# tímar}} eftir",
  "time_remaining.minutes": "{number, plural, one {# minuttur} other {# minuttir}} eftir",
  "time_remaining.moments": "Lítið bil eftir",
  "time_remaining.seconds": "{number, plural, one {# sekund} other {# sekund}} eftir",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persónur} other {{counter} persónar}} {days, plural, one {seinasta dagin} other {{days} seinastu dagarnar}}",
  "trends.trending_now": "Rák beint nú",
  "ui.beforeunload": "Kladdan verður mist, um tú fer úr Mastodon.",
  "units.short.billion": "{count} mia.",
  "units.short.million": "{count} mn.",
  "units.short.thousand": "{count} túsund",
  "upload_area.title": "Hála og slepp fyri at leggja upp",
  "upload_button.label": "Legg myndir, sjónfílu ella ljóðfílu afturat",
  "upload_error.limit": "Farið er um markið fyri fíluuppsending.",
  "upload_error.poll": "Ikki loyvt at leggja fílur upp í spurnarkanningum.",
  "upload_error.quote": "Ikki loyvt at leggja fílur upp við siteringum.",
  "upload_form.drag_and_drop.instructions": "Fyri at heinta eitt miðlaviðfesti, trýst á millumrúm ella returknapp. Meðan tú dregur, brúka pílarnar fyri at flyta miðaviðfesti í einhvønn rætning. Trýst á millumrúm ella returknapp aftur fyri at sleppa miðlaviðfestinum í nýggja staðnum ella trýst á esc-knappin fyri at angra.",
  "upload_form.drag_and_drop.on_drag_cancel": "Draging varð steðgað. Miðlaviðfestið {item} varð slept.",
  "upload_form.drag_and_drop.on_drag_end": "Miðlaviðfestið {item} var slept.",
  "upload_form.drag_and_drop.on_drag_over": "Miðlaviðfestið {item} var flutt.",
  "upload_form.drag_and_drop.on_drag_start": "Heintaði miðlaviðfestið {item}.",
  "upload_form.edit": "Rætta",
  "upload_progress.label": "Leggi upp...",
  "upload_progress.processing": "Viðgeri…",
  "username.taken": "Brúkaranavnið er tikið. Royn eitt annað",
  "video.close": "Lat sjónfílu aftur",
  "video.download": "Tak fílu niður",
  "video.exit_fullscreen": "Far úr fullum skermi",
  "video.expand": "Víðka sjónfílu",
  "video.fullscreen": "Fullur skermur",
  "video.hide": "Fjal sjónfílu",
  "video.mute": "Doyv",
  "video.pause": "Steðga á",
  "video.play": "Spæl",
  "video.skip_backward": "Leyp um aftureftir",
  "video.skip_forward": "Leyp um frameftir",
  "video.unmute": "Doyv ikki",
  "video.volume_down": "Minka ljóðstyrki",
  "video.volume_up": "Øk um ljóðstyrki",
  "visibility_modal.button_title": "Set sýni",
  "visibility_modal.direct_quote_warning.text": "Um tú goymir verandi stillingar, verður innskotna sitatið umskapað til eitt leinki.",
  "visibility_modal.direct_quote_warning.title": "Sitatir kunnu ikki innskjótast í privatar umrøður",
  "visibility_modal.header": "Sýni og samvirkni",
  "visibility_modal.helper.direct_quoting": "Privatar umrøður, sum eru skrivaðar á Mastodon, kunnu ikki siterast av øðrum.",
  "visibility_modal.helper.privacy_editing": "Sýni kann ikki broytast eftir, at ein postur er útgivin.",
  "visibility_modal.helper.privacy_private_self_quote": "Sjálv-sitering av privatum postum kann ikki gerast almenn.",
  "visibility_modal.helper.private_quoting": "Postar, sum einans eru fyri fylgjarar á Mastodon, kunnu ikki siterast av øðrum.",
  "visibility_modal.helper.unlisted_quoting": "Tá fólk sitera teg, so vera teirra postar eisini fjaldir frá tíðarlinjum við ráki.",
  "visibility_modal.instructions": "Stýr hvør samvirka við hendan postin. Tú kanst eisini áseta stillingar til allar framtíðar postar við at fara til <link>Stillingar > Postingarstillingar</link>.",
  "visibility_modal.privacy_label": "Sýni",
  "visibility_modal.quote_followers": "Einans fylgjarar",
  "visibility_modal.quote_label": "Hvør kann sitera",
  "visibility_modal.quote_nobody": "Bara eg",
  "visibility_modal.quote_public": "Ein og hvør",
  "visibility_modal.save": "Goym"
}
